/**
 * Web Style Import
 *
 */

import '../icon/style/dnb-icon.scss'
